<template>
  <div class="flex goods-share-container">
    <div class="preview-wrapper">
      <div
        class="popup-wrapper"
        :style="{ backgroundImage: 'url(' + ruleForm.backgroundImg + ')' }"
      >
        <div class="popup-top">
          <div
            class="avatar-wrapper"
            v-if="ruleForm.memberHeadPortraitState === 'yes'"
          >
            <img
              src="https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/93b50b2a24cf58baed5f37e354f40b0.png"
              alt
            />
          </div>
          <div class="title">
            <div><span v-if="ruleForm.memberNameState === 'yes'">小赖，</span>邀你观看</div>
            <div v-if="ruleForm.spuNameState === 'yes'">直播主题直播主题直播主题</div>
          </div>
        </div>  
        <div class="background-img">
          <img
            :src="defaultGoods"
            alt
          />
        </div>
        <div class="popup-bottom">
          <div class="remark">
            <span v-if="ruleForm.recommendWordState === 'yes'">{{
              ruleForm.recommendWordType === "custom"
                ? ruleForm.customizeWord
                : ""
            }}</span>
          </div>
          <div
            class="start-time"
          >
            <span v-if="ruleForm.spuPriceState === 'yes'">开播时间：07.05 10:00-12:00</span>
          </div>  
          <div
            class="anchor-name"
          >
            <span v-if="ruleForm.spuBasePriceState === 'yes'">主播昵称：XX主播</span>
          </div>
          <div class="footer">
            <div class="mp-code">
              <img
                src="https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/mpcode.png"
                alt
              />
            </div>
            <div
              class="column-name text-center"
            >
              长按识别
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-card class="card flex-1">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-form-item label="模板展示顺序：">
          <el-input
            size="small"
            type="number"
            placeholder="请输入模板展示顺序数字"
            v-model="ruleForm.seqNum"
          ></el-input>
          <div class="form-tip">设置页面展示顺序，数字越小越靠前</div>
        </el-form-item>
        <el-form-item label="模板启用状态：" prop="">
          <div class="switch-wrapper" style="width:380px">
            <el-switch
              v-model="ruleForm.enabledState"
              size="mini"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="yes"
              inactive-value="no"
            ></el-switch>
          </div>
        </el-form-item>
        <el-form-item label="默认背景图：" prop="">
          <div class="flex upload-upload-btn">
            <div
              class="btn flex flex-column flex-center open-file"
              @click="hmUploadVisible = true"
              v-if="!ruleForm.backgroundImg"
            >
              <div class="add-wrapper">
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <span>上传</span>
            </div>
            <div
              v-if="ruleForm.backgroundImg"
              class="priview mr10 flex item-end"
            >
              <img :src="ruleForm.backgroundImg" alt="主图" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
          </div>
          <span class="form-tip"
            >只能上传jpg/png文件，且不能超过1MB建议图片尺寸为650x940像素</span
          >
        </el-form-item>
        <el-form-item label="会员头像：" prop="">
          <el-radio-group
            v-model="ruleForm.memberHeadPortraitState"
            size="small"
          >
            <el-radio label="yes">显示</el-radio>
            <el-radio label="no">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="会员姓名：" prop="">
          <el-radio-group v-model="ruleForm.memberNameState" size="small">
            <el-radio label="yes">显示</el-radio>
            <el-radio label="no">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="推荐语：" prop="">
          <el-radio-group v-model="ruleForm.recommendWordState" size="small">
            <el-radio label="yes">显示</el-radio>
            <el-radio label="no">隐藏</el-radio>
          </el-radio-group>
          <div>
            <el-radio-group
              v-if="ruleForm.recommendWordState === 'yes'"
              v-model="ruleForm.recommendWordType"
              size="small"
              @change="ruleForm.customizeWord = ''"
            >
              <div class="flex">
                <el-radio label="custom">自定义推荐语内容</el-radio>
                <el-input
                  :rows="4"
                  maxlength="140"
                  type="textarea"
                  v-model.trim="ruleForm.customizeWord"
                  placeholder="请输入推荐语，限制140字以内"
                />
              </div>
              <!-- <div>
                <el-radio label="sellingPoint">使用商品卖点</el-radio>
              </div> -->
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="直播主题：" prop="">
          <el-radio-group v-model="ruleForm.spuNameState" size="small">
            <el-radio label="yes">显示</el-radio>
            <el-radio label="no">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开播时间：" prop="">
          <el-radio-group v-model="ruleForm.spuPriceState" size="small">
            <el-radio label="yes">显示</el-radio>
            <el-radio label="no">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="主播昵称：" prop="">
          <el-radio-group v-model="ruleForm.spuBasePriceState" size="small">
            <el-radio label="yes">显示</el-radio>
            <el-radio label="no">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <div class="flex flex-center">
            <el-button type="primary" size="small" @click="save('ruleForm')"
              >保存</el-button
            >
            <el-button type="default" size="small" @click="backPrev"
              >返回</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-card>
    <hm-upload
      :hmUploadVisible="hmUploadVisible"
      fileDir="decoration"
      @cancleUpload="cancleUpload"
      @hmUploadSuccess="hmUploadSuccess"
    ></hm-upload>
  </div>
</template>

<script>
import HmUpload from "@/components/HmUpload";
import html2canvas from "html2canvas";

export default {
  components: {
    HmUpload
  },
  data() {
    return {
      hmUploadVisible: false,
      defaultGoods:
        "https://imgcdn.hemiao100.com/hemiaoBase/live/liveShareTemp_02.png",
      defaultBg:
        "https://imgcdn.hemiao100.com/hemiaoBase/live/liveShareBg.png",
      bg: "",
      rules: {},
      mode: "",
      shareId: "",
      ruleForm: {        
        seqNum: "",
        enabledState: "yes",
        backgroundImg: "",
        memberHeadPortraitState: "yes",
        memberNameState: "yes",
        recommendWordState: "yes",
        recommendWordType: "custom",
        customizeWord: "",
        spuNameState: "yes",
        spuPriceState: "yes",
        spuBasePriceState: "yes",
        columnNameState: "yes",
        columnName: "",
        spuImgType: "",
        previewImg: ""
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    this.ruleForm.backgroundImg = this.defaultBg;
    this.mode = this.$route.query.mode;
    this.shareId = this.$route.query.shareId;
    const goodsTempRow = this.$store.state.decoration.goodsTempRow;
    for (let key in goodsTempRow) {
      if (this.ruleForm.hasOwnProperty(key)) {
        this.ruleForm[key] = goodsTempRow[key];
      }
    }
  },
  mounted() {},
  destroyed() {
    this.$store.commit("SET_GOODS_TEMP_ROW", {});
  },
  methods: {
    hmUploadSuccess(url) {
      this.ruleForm.backgroundImg = url;
      this.hmUploadVisible = false;
    },
    cancleUpload() {
      this.hmUploadVisible = false;
    },
    handleRemove() {
      this.ruleForm.backgroundImg = "";
    },
    async save(formName) {
      const canvas = await html2canvas(
        document.querySelector(".preview-wrapper"),
        {
          useCORS: true,
          backgroundColor: null
        }
      );
      const previewImg = canvas.toDataURL("image/png");
      const valid = await this.$refs[formName].validate();
      if (valid) {
        const params = JSON.parse(JSON.stringify(this.ruleForm));
        Object.assign(params, {
          previewImg,
          sharePageType: "live"
        });
        let commitName = "addGoodShareTemp";
        if (this.mode === "edit") {
          commitName = "editGoodShareTemp";
          Object.assign(params, {
            shareId: this.shareId
          });
        }
        const result = await this.$store.dispatch(commitName, params);
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.backPrev();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.goods-share-container {
  position: relative;
}
.preview-wrapper {
  position: fixed;
  top: 100px;
  width: 375px;
  height: 667px;
  background-image: url(https://imgcdn.hemiao100.com/36098302136909/decoration/2020-02-16/d33c78ce9e0c1f4bab3fff0c007bb07.png);
  background-size: 100% 100%;
  margin-right: 20px;
  .popup-wrapper {
    position: relative;
    margin: 90px auto 0;
    width: 295px;
    height: 440px;
    background-size: 100% 100%;
    .popup-top{
      padding: 45px 30px 0 30px;
    }
    .avatar-wrapper {
      background: #fff;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      margin-right: 10px;
      position: absolute;
      left: 50%;
      top: 20px;
      transform: translateX(-50%);
      img {
        width: 100%;
      }
    }

    .goods-wrapper {
      // position: absolute;
      // top: 144px;
      // left: 50%;
      width: 200px;
      height: 200px;
      transform: translateX(-50%);
      &.enlarge {
        top: 134px;
        width: 225px;
        height: 225px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }

    .title {
      // position: absolute;
      // top: 12px;
      // left: 42px;
      text-align: center;
      font-weight: bold;
      font-size: 15px;
      width: 230px;
      height: 34px;
    }

    .background-img{
      width: 236px;
      height: 236px;
      overflow: hidden;
      margin: 10px 30px;
      img{
        width: 100%;
        height: 100%;
      }
    }

    .remark {
      // position: absolute;
      // top: 57px;
      // left: 12px;
      padding: 8px 0 0 30px;
      font-size: 12px;
      line-height: 14px;
      height: 28px;
      overflow: hidden;
      width: 160px;
      color: #666;
      word-break: break-all;
      // text-indent: 2em;
    }

    .start-time{
      font-size: 12px;
      height: 14px;
      color: #999999;
      padding: 8px 0 0 30px;
    }
    .anchor-name{
      font-size: 12px;
      height: 14px;
      color: #999999;
      padding: 8px 0 0 30px;
    }

    .footer {
      position: absolute;
      right: 30px;
      top: 10px;
      .mp-code {
        width: 54px;
        height: 54px;
        padding: 0;
        margin: 0;
        img {          
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .column-name {
        font-size: 10px;
        width: 100%;
        margin-top: 5px;
      }
    }
  }
}

.activity-tag {
  position: absolute;
  background: #f72b2b;
  color: #fff;
  top: 363px;
  left: 30px;
  transform: scale(0.8);
  font-size: 12px;
  padding: 2px 5px;
}

.switch-wrapper {
  text-align: right;
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 130px;
    height: 130px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}

.card {
  margin-left: 385px;
}
.priview {
  position: relative;
  width: 152px;
  min-height: 152px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.popup-bottom{
  width: 295px;
  height: 141px;
  position: relative;
}

</style>
